export const initialTableFilters = {
    email: '',
    first_name: '',
    user_name: '',
};
